module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/axios/index.js
// module id = 3
// module chunks = 0 1 2 3